import { type JSX } from 'react/jsx-runtime';

import { GenericBanner } from '../../../components/generic-banner';
import { PersonalizedBanner } from '../../../components/personalized-banner';
import { createRender, type HydrationResult } from './types';
import { useHandleDismiss } from './use-handle-dismiss';

const getDismissClickIdentifier = (arm: HydrationResult['arm']) => {
	switch (arm) {
		case 'personalized':
			return 'twc-sidenav-banner-personalized-dismiss';
		case 'generic':
			return 'twc-sidenav-banner-generic-dismiss';
		default:
			return 'twc-sidenav-banner-dismiss';
	}
};

export const render: (
	renderProps: Omit<HydrationResult, 'postOffice'> & {
		onDismissed: () => void;
	},
) => JSX.Element | null = createRender(
	({
		redirectTo,
		onboardingUrl,
		onDismissed,
		messageInstanceId,
		locale,
		arm,
		recommendedApp,
		experimentKey,
		actionTier,
		targetTenantId,
		collectionEntitlementId,
	}) => {
		const { handleDismiss } = useHandleDismiss({
			onDismissed,
			clickIdentifier: getDismissClickIdentifier(arm),
		});

		// arm drives all rendering decisions — no fallback to other conditions.
		if (arm === 'personalized' && recommendedApp && actionTier) {
			return (
				<PersonalizedBanner
					locale={locale}
					recommendedApp={recommendedApp}
					onClose={handleDismiss}
					onCtaClick={handleDismiss}
					href={onboardingUrl}
					messageInstanceId={messageInstanceId}
					experimentKey={experimentKey}
					actionTier={actionTier}
					targetTenantId={targetTenantId}
					collectionEntitlementId={collectionEntitlementId}
					surfaceProduct="jira"
				/>
			);
		}

		if (arm === 'generic') {
			return (
				<GenericBanner
					locale={locale}
					product={redirectTo}
					onClose={handleDismiss}
					onCtaClick={handleDismiss}
					href={onboardingUrl}
					messageInstanceId={messageInstanceId}
					surfaceProduct="jira"
				/>
			);
		}

		// control (or any unrecognised arm): no banner shown.
		return null;
	},
);

export default render;
